export interface IPaymentProvidersState {
  mainProvider: TPaymentProvider;
  sbpProvider: TPaymentProvider;
}

export type TPaymentProvider = EPaymentProvider | null;
export enum EPaymentProvider {
  YooKassa = 'yooKassa',
  CloudPayments = 'cloudPayments',
}
